<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout-task-top-main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

    <!-- Navbar -->
    <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
      <the-navbar-horizontal
        :navbarType= "navbarType"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />

      <div style="height: 62px" v-if="navbarType === 'static'"></div>
    </template>

    <template v-else>
      <the-task-top-navbar-vertical
        :workspaceList="workspaceList"
        :seleleteItem="seleleteItem"
        :navbarColor="navbarColor"
        v-on:selectWorkspace="selectWorkspace"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
    <!-- /Navbar -->

    <div class="content-wrapper">

      <div class="router-view">

        <div class="router-content" style="margin:10px">

            <div class="content-area__content">
              <div class="ml-auto md:block cursor-pointer">
                <p class="flex text-dark" style="font-size:18px;"  v-if="windowWidth >= 992" ><strong>{{projectSelected.label}} </strong></p>
                <div class="vx-row" style="padding-top:10px; padding-left:10px; padding-bottom:20px;">
                <v-select class="lg:w-1/6 md:w-1/4 sm:w-1/3" style="margin-left:5px; margin-right:15px;"  v-model="projectSelected" :options="projectOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <div class="vx-row justify-end">
                  <vs-button style="padding:12px; margin-left:5px; margin-right:3px;" color="warning" type="flat" icon="icon-share-2" icon-pack="feather" @click="showInvitePopup()" >멤버초대</vs-button>
                  <vs-button style="margin-left:5px; margin-right:3px;" color="dark" type="filled" icon="icon-check-circle" icon-pack="feather">완료</vs-button>
                </div>
              </div>
            </div>
            <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
              <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
            </back-to-top>
            <transition :name="routerTransition" mode="out-in">
              <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
            </transition>
           </div>
         </div>
       </div>
     </div>
    <the-footer/>
    <vs-popup classContent="popup-example" title="멤버 초대" :active.sync="inviteMemberPopup">
      <div class="vx-row text-left" style="margin:10px;">
      <p><strong> URL로 초대하기</strong></p>
      <vs-button color="primary" type="flat" size="small" icon-pack="feather" icon="icon-copy"/></div>
      <p style="margin:10px;"> https://filledyou.com/apps/project/main/{{projectSelected.id}} </p>
      <p style="margin:10px;"> 검증코드: {{projectSelected.pin_number}}</p>
      <vs-divider position="center"> 또는 </vs-divider>
      <div class="vx-row text-left" style="margin:10px;">
       <p style="margin:3px;"><strong> Email로 초대하기</strong></p>
       <vs-textarea v-model="emails" placeholder="예)user01@filledyou.com;user02@filledyou.com"/> <br>
       </div>
      <vs-button class="w-full" @click="inviteMember()" color="primary" type="filled">초대하기</vs-button>
    </vs-popup>
  </div>
  </div>
</template>


<script>
import BackToTop           from 'vue-backtotop'
// import HNavMenu            from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
import navMenuItems        from "@/layouts/components/vertical-nav-menu/navMenuItems.js"
// import TheCustomizer       from "@/layouts/components/customizer/TheCustomizer.vue"
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
// import TheTopNavbarVertical   from '@/layouts/components/navbar/TheTopNavbarVertical.vue'
import TheTaskTopNavbarVertical   from '@/layouts/components/navbar/TheTaskTopNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import vSelect             from 'vue-select'
import moduleProjectBlog from '@/store/project_blog/moduleProjectBlog.js'
// import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'

// const VxTour = () => import('@/components/VxTour.vue')

export default {
  components: {
    BackToTop,
    TheFooter,
    TheNavbarHorizontal,
    moduleProjectBlog,
    TheTaskTopNavbarVertical,
    'v-select': vSelect,
  },
  data() {
    return {
      inviteMemberPopup: false,
      emails:'',
      val:'',
      value1:'',
      workspaceList:[],
      projectSelected:'',
      seleleteItem:{id: 1, label: '없음'},
      disableCustomizer : themeConfig.disableCustomizer,
      disableThemeTour  : themeConfig.disableThemeTour,
      dynamicWatchers   : {},
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuItems      : navMenuItems,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      steps: [{
          target  : '#btnVNavMenuMinToggler',
          content : 'Toggle Collapse Sidebar.'
        },
        {
          target  : '.vx-navbar__starred-pages',
          content : 'Create your own bookmarks. You can also re-arrange them using drag & drop.'
        },
        {
          target  : '.i18n-locale',
          content : 'You can change language from here.'
        },
        {
          target  : '.navbar-fuzzy-search',
          content : 'Try fuzzy search to visit pages in flash.'
        },
        {
          target  : '.customizer-btn',
          content : 'Customize template based on your preference',
          params  : {
            placement: 'left'
          }
        },
         {
           target  : '.vs-button.buy-now',
           content : 'Buy this awesomeness at affordable price!',
           params  : {
             placement: 'top'
           }
         },
      ],
    }
  },
  watch: {
    "$route"() {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff"
      this.updateNavbarColor(color)
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val)
      this.disableThemeTour = true
    },
    projectSelected(val){
      if(this.$route.params.projectId != val.id){
        this.$router.push('/apps/project/main/'+val.id)
      }
    }
  },
  computed: {
    projectOptions(){
      return this.$store.state.project.projects
    },
    bodyOverlay() { return this.$store.state.bodyOverlay },
    contentAreaClass() {
      if(this.mainLayoutType === "vertical") {
        if      (this.verticalNavMenuWidth == "default") return "content-area-reduced"
        else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
        else return "content-area-full"
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full"
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      }
    },
    isAppPage() {
      return this.$route.meta.no_scroll
    },
    isThemeDark()     { return this.$store.state.theme == 'dark' },
    layoutTypeClass() { return `main-${this.mainLayoutType}` },
    mainLayoutType()  { return this.$store.state.mainLayoutType  },
    navbarClasses()   {
      return {
        'navbar-hidden'   : this.navbarType == 'hidden',
        'navbar-sticky'   : this.navbarType == 'sticky',
        'navbar-static'   : this.navbarType == 'static',
        'navbar-floating' : this.navbarType == 'floating',
      }
    },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth },
    windowWidth()          { return this.$store.state.windowWidth }
  },
  methods: {
    showInvitePopup() {
      this.inviteMemberPopup = true
    },
    inviteMember(){
      this.$vs.loading()
      const payload = {
          emails: this.emails,
          projectId: this.$route.params.projectId
      }
      this.$store.dispatch('project/inviteProject', payload).then((resolve)=>{
        this.$vs.loading.close()
        if(resolve.data.result == 'success'){
          this.$vs.notify({
            color: 'success',
            title: '초대 완료'
          })
          this.inviteMemberPopup = false
        }
      }).catch(() => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: '에러',
          text: '관리자에게 문의해주세요',
          color: 'danger'
        })
        this.inviteMemberPopup = false
      })

    },
    selectWorkspace(){
      if(this.$store.state.project.projects.length != 0){
        this.$store.commit('project/SET_SELECT_PROJECT', this.$store.state.project.projects[0])
        this.projectSelected = this.$store.state.project.selectProjectInfo
      }
    },
    createSpace() {
      this.$router.push('/pages/space/create')
    },
    spaceAll() {
      this.$router.push('/apps/space/all')
    },
    spaceDivide() {
      this.$router.push('/apps/space')
    },
    changeRouteTitle(title) {
      this.routeTitle = title
    },
    updateNavbar(val) {
      if (val == "static") this.updateNavbarColor(this.isThemeDark ? "#10163a" : "#fff")
      this.navbarType = val
    },
    updateNavbarColor(val) {
      this.navbarColor = val
      if (val == "#fff") this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter(val) {
      this.footerType = val
    },
    updateRouterTransition(val) {
      this.routerTransition = val
    },
    setNavMenuVisibility(layoutType) {
      if((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      }
      else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val
    }
  },
  beforeCreate() {
    if (!localStorage.getItem("filleduToken") && !sessionStorage.getItem("filleduToken")) {
      this.$router.push('/pages/login')
    }
  },
  created() {
    this.$store.registerModule('projectBlog', moduleProjectBlog)
    this.$store.dispatch('project/getWorkspaceProject').then(()=>{
      var index = 0
      var projectList = []
      var workspaceProjects = this.$store.state.project.workspaceProjects
      index = workspaceProjects.findIndex((e) => e.id == Number(this.$route.params.projectId))
      this.$store.commit('project/SET_SELECT_WORKSPACE', {id: workspaceProjects[index].workspace_id, label: workspaceProjects[index].workspace_title})
      this.seleleteItem = this.$store.state.project.selectWorkspaceInfo

      for(index in workspaceProjects){
        var findIndex = this.workspaceList.findIndex((e) => e.id == workspaceProjects[index].workspace_id)

        if(findIndex == -1){
          this.workspaceList.push({id:workspaceProjects[index].workspace_id, label: workspaceProjects[index].workspace_title})
        }
        if(workspaceProjects[index].workspace_id == this.$store.state.project.selectWorkspaceInfo.id) {
          projectList.push(workspaceProjects[index])
        }
      }
      this.$store.commit('project/SET_PROJECT_LIST', projectList)
      index = projectList.findIndex((e) => e.id == this.$route.params.projectId)
      this.$store.commit('project/SET_SELECT_PROJECT', projectList[index])
      this.projectSelected = this.$store.state.project.selectProjectInfo
    })

    const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)

    // Dynamic Watchers for tour
    // Reason: Once tour is disabled it is not required to enable it.
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch("$store.state.windowWidth", (val) => {
      if(val < 1200) {
        this.disableThemeTour = true
        this.dynamicWatchers.windowWidth()
      }
    })

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch("$store.state.verticalNavMenuWidth", () => {
      this.disableThemeTour = true
      this.dynamicWatchers.verticalNavMenuWidth()
    })

    this.dynamicWatchers.rtl = this.$watch("$vs.rtl", () => {
      this.disableThemeTour = true
      this.dynamicWatchers.rtl()
    })
  },
  beforeDestroy() {
    this.$store.unregisterModule('projectBlog')
    Object.keys(this.dynamicWatchers).map(i => {
      this.dynamicWatchers[i]()
      delete this.dynamicWatchers[i]
    })
  }
}

</script>
